<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import { api } from "@/state/services";
import { formatPoints, formatPlace } from "@/state/helpers/experiences";

// Detalhe da experiência: conteúdo à esquerda e resumo com o botão de resgate
export default {
  components: { Layout, Breadcrumb },
  data() {
    return {
      loading: true,
      errored: false,
      empty: false,
      experience: null,
      balance: 0,
    };
  },
  computed: {
    balanceAfter() {
      return this.experience ? this.balance - this.experience.points : 0;
    },
  },
  methods: {
    formatPoints,
    formatPlace,
    load() {
      this.loading = true;
      this.errored = false;
      this.empty = false;

      api
        .get("experiences/" + this.$route.params.id)
        .then((response) => {
          if (response.data.status == "success") {
            this.experience = response.data.experience;
            this.balance = Number(response.data.balance) || 0;
          } else {
            this.empty = true;
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Experiências', to: '/experiences' }, { text: 'Detalhe' }]" />

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>
    <div v-else-if="errored" class="text-center py-5">
      <p>Pedimos desculpas, não podemos recuperar as informações neste momento.</p>
      <button class="btn btn-default" v-on:click="load()">Tentar novamente</button>
    </div>
    <div v-else-if="empty" class="ds-page">
      <div class="ds-box ds-result text-center">
        <i class="bx bx-error-circle ds-result-icon" aria-hidden="true"></i>
        <h4>Experiência não encontrada</h4>
        <p class="text-muted mb-4">Ela pode ter sido encerrada ou não está mais disponível.</p>
        <router-link tag="a" to="/experiences" class="btn btn-default btn-lg btn-block text-uppercase">Ver experiências</router-link>
      </div>
    </div>
    <div v-else-if="experience" class="ds-page">
      <div class="ds-intro">
        <h1 class="ds-title">{{ experience.title }}</h1>
        <p class="ds-subtitle">{{ experience.summary }}</p>
      </div>

      <div class="row">
        <div class="col-lg-8 ex-stack">
          <div class="ds-box ds-box-wide">
            <div class="ex-cover mb-3">
              <img v-if="experience.image" :src="experience.image" :alt="experience.title">
              <span v-else class="ex-cover-empty"><i class="bx bx-gift" aria-hidden="true"></i></span>
            </div>
            <div class="ex-content" v-html="experience.description"></div>
          </div>
          <div class="ds-box ds-box-wide">
            <h5 class="mb-3">O que está incluído</h5>
            <div class="ex-content" v-html="experience.includes"></div>
          </div>
          <div v-if="experience.rules" class="ds-box ds-box-wide">
            <h5 class="mb-3">Observações e regras</h5>
            <div class="ex-content" v-html="experience.rules"></div>
          </div>
          <div class="ds-box ds-box-wide">
            <h5 class="mb-3">Parceiro</h5>
            <p class="mb-1"><strong>{{ experience.partner.name }}</strong></p>
            <p class="text-muted mb-2">{{ [experience.partner.address, formatPlace(experience.partner)].filter(Boolean).join(' · ') }}</p>
            <a v-if="experience.partner.mapUrl" :href="experience.partner.mapUrl" target="_blank" rel="noopener" class="btn btn-outline-default btn-sm">
              Como chegar <i class="bx bx-link-external align-middle"></i>
            </a>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="ds-box ds-box-wide ds-summary">
            <h5 class="mb-3">Resumo</h5>
            <dl>
              <div>
                <dt>Experiência</dt>
                <dd>{{ experience.title }}</dd>
              </div>
              <div>
                <dt>Parceiro</dt>
                <dd>{{ experience.partner.name }}</dd>
              </div>
              <div>
                <dt>Preço</dt>
                <dd>{{ formatPoints(experience.points) }}</dd>
              </div>
              <div>
                <dt>Seu saldo</dt>
                <dd>{{ formatPoints(balance) }}</dd>
              </div>
              <div v-if="experience.canRedeem" class="is-total">
                <dt>Após resgate</dt>
                <dd>{{ formatPoints(balanceAfter) }}</dd>
              </div>
            </dl>

            <router-link v-if="experience.canRedeem" tag="a" :to="'/experiences/' + experience.id + '/redeem'" class="btn btn-default btn-lg btn-block text-uppercase">Resgatar</router-link>
            <button v-else-if="experience.soldOut" class="btn btn-default btn-lg btn-block text-uppercase" disabled>Indisponível</button>
            <button v-else class="btn btn-default btn-lg btn-block text-uppercase" disabled>Faltam {{ formatPoints(experience.missingPoints) }}</button>
            <router-link tag="a" to="/experiences" class="btn btn-outline-default btn-lg btn-block text-uppercase mt-2">Voltar</router-link>

            <div class="ds-note mt-3">
              <i class="bx bx-info-circle" aria-hidden="true"></i>
              <span>Os pontos são debitados agora; a compra passa por aprovação da equipe.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
